import React, { useEffect, useState, useRef } from 'react';
import './Toast.scss';

export type ToastType = 'success' | 'error';

interface ToastProps {
  message: string;
  type: ToastType;
  duration?: number;
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({
  message,
  type,
  duration = 3000,
  onClose
}) => {
  const [visible, setVisible] = useState(true);
  const progressRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  useEffect(() => {
    if (progressRef.current) {
      const el = progressRef.current;

      el.style.transition = 'none';
      el.style.width = '100%';

      requestAnimationFrame(() => {
        el.style.transition = `width ${duration}ms linear`;
        el.style.width = '0%';
      });
    }
  }, [duration]);

  if (!visible) return null;

  return (
    <div className={`toast toast--${type}`}>
      <span>{message}</span>
      <button
        className="toast__close"
        aria-label="Close"
        title="Close"
        onClick={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
      >
        &times;
      </button>
      <div className="toast__progress" ref={progressRef}></div>
    </div>
  );
};

export default Toast;
